import { ComponentRegistry, sharedComponentRegistry } from '@repo/roche-xx-shared';
import { forms } from './forms';
import { GatherContentMigrationHelper } from './gather-content-migration-helper';
import { HtmlBlob } from './html-blob';
import { Marketo } from './marketo';
import { Podcast } from './podcast';
import { PubMed } from './pub-med';
import { RocheAddToCalendar } from './roche-add-to-calendar';
import { RocheAnimatedWords } from './roche-animated-words';
import { RocheBackToBranch } from './roche-back-to-branch';
import { RocheHorizontalCenter } from './roche-horizontal-center';
import { RocheInvestorEventsList } from './roche-investor-events-list';
import { RocheInvestorUpdatesList } from './roche-investor-updates-list';
import { RocheMediaEventsList } from './roche-media-events-list';
import { RocheMediaReleases } from './roche-media-releases';
import { RocheMediaReleasesInvestorUpdatesAdhoc } from './roche-media-releases-investor-updates-adhoc';
import { RocheMediaSwitzerland } from './roche-media-switzerland';
import { RocheModal } from './roche-modal';
import { RocheOnClickNotice } from './roche-on-click-notice';
import { RocheOnLoadNotice } from './roche-on-load-notice';
import { RochePatientOrganisations } from './roche-patient-organisations';
import { RochePipeline } from './roche-pipeline';
import { RochePipelineChanges } from './roche-pipeline-changes';
import { RochePipelineDiagnostics } from './roche-pipeline-diagnostics';
import { RocheResponsiveTable } from './roche-responsive-table';
import { RocheSafetyOfficersOverview } from './roche-safety-officers-overview';
import { RocheSafetyReportingOverview } from './roche-safety-reporting-overview';
import { RocheSearch } from './roche-search';
import { RocheVideoPlayer } from './roche-video-player';

export const componentRegistry: ComponentRegistry = {
  ...sharedComponentRegistry,
  ...forms,
  GatherContentMigrationHelper,
  HtmlBlob,
  Marketo,
  Podcast,
  PubMed,
  RocheAddToCalendar,
  RocheAnimatedWords,
  RocheBackToBranch,
  RocheMediaReleasesInvestorUpdatesAdhoc,
  RocheHorizontalCenter,
  RocheInvestorEventsList,
  RocheInvestorUpdatesList,
  RocheMediaEventsList,
  RocheMediaReleases,
  RocheMediaSwitzerland,
  RocheModal,
  RocheOnClickNotice,
  RocheOnLoadNotice,
  RochePatientOrganisations,
  RochePipeline,
  RochePipelineChanges,
  RochePipelineDiagnostics,
  RocheResponsiveTable,
  RocheSafetyOfficersOverview,
  RocheSafetyReportingOverview,
  RocheSearch,
  RocheVideoPlayer,
};
